import { FormDoc, User } from '@vyce/core/src/types';

import type { FormSummaryTitleProps } from '../components/FormSummaryTitle';

export function buildFormSummaryTitleProps(
  form: FormDoc | null,
  user: User,
  options?: { withResponseMetrics?: boolean }
): FormSummaryTitleProps {
  const base: FormSummaryTitleProps = {
    title: form?.title ?? '',
    status: form?.status ?? '',
    description: form?.description,
    createdByName: form?.createdByName,
    createdAt: form?.createdAt ?? null,
    companyId: form?.companyId ?? '',
    formId: form?.id ?? '',
    user,
  };

  if (options?.withResponseMetrics) {
    return {
      ...base,
      sent: form?.sendTo ?? 0,
      completed: form?.filled ?? 0,
    };
  }

  return base;
}
